import { client, formatQueryParams } from 'util/sdk';

export default ({ fspId, payerId, ...params }) =>
  client
    .fsps(fspId)
    .payers(payerId)
    .notifications.query(formatQueryParams(params));
